import { render, staticRenderFns } from "./combineRecords.vue?vue&type=template&id=4fc08781&scoped=true&"
import script from "./combineRecords.vue?vue&type=script&lang=js&"
export * from "./combineRecords.vue?vue&type=script&lang=js&"
import style0 from "./combineRecords.vue?vue&type=style&index=0&id=4fc08781&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fc08781",
  null
  
)

component.options.__file = "combineRecords.vue"
export default component.exports